var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStrokeProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cv 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.1764 3.38841C21.1764 1.90605 19.9764 0.706055 18.4941 0.706055H5.50584C4.02349 0.706055 2.82349 1.90605 2.82349 3.38841V20.6119C2.82349 22.0943 4.02349 23.2943 5.50584 23.2943H18.4941C19.9764 23.2943 21.1764 22.0943 21.1764 20.6119V3.38841ZM19.7647 20.6119C19.7647 21.3178 19.2 21.8825 18.4941 21.8825H5.50584C4.79996 21.8825 4.23525 21.3178 4.23525 20.6119V3.38841C4.23525 2.68253 4.79996 2.11782 5.50584 2.11782H18.4941C19.2 2.11782 19.7647 2.68253 19.7647 3.38841V20.6119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.69416 13.4121H16.0236C16.2353 13.4121 16.4471 13.3415 16.5883 13.1297C16.7295 12.9886 16.8 12.7768 16.7295 12.565C16.4471 10.8709 15.3883 9.52975 13.9765 8.89445C14.4 8.40033 14.6824 7.76504 14.6824 6.98857C14.6824 5.43563 13.4118 4.16504 11.8589 4.16504C10.3059 4.16504 9.03534 5.43563 9.03534 6.98857C9.03534 7.69445 9.31769 8.32975 9.74122 8.89445C8.32946 9.60033 7.20005 10.9415 6.98828 12.565C6.98828 12.7768 6.98828 12.9886 7.12946 13.1297C7.27063 13.3415 7.4824 13.4121 7.69416 13.4121ZM10.4471 7.05916C10.4471 6.28269 11.0824 5.64739 11.8589 5.64739C12.6353 5.64739 13.2706 6.28269 13.2706 7.05916C13.2706 7.83563 12.6353 8.47092 11.8589 8.47092C11.0824 8.47092 10.4471 7.83563 10.4471 7.05916ZM11.8589 9.88269C13.2706 9.88269 14.5412 10.7297 15.1059 12.0003H8.61181C9.17652 10.7297 10.4471 9.88269 11.8589 9.88269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.647 15.5298H6.35286C5.92933 15.5298 5.64697 15.8121 5.64697 16.2357C5.64697 16.6592 5.92933 16.9415 6.35286 16.9415H17.647C18.0705 16.9415 18.3529 16.6592 18.3529 16.2357C18.3529 15.8121 18.0705 15.5298 17.647 15.5298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.647 18.353H6.35286C5.92933 18.353 5.64697 18.6354 5.64697 19.0589C5.64697 19.4824 5.92933 19.7648 6.35286 19.7648H17.647C18.0705 19.7648 18.3529 19.4824 18.3529 19.0589C18.3529 18.6354 18.0705 18.353 17.647 18.353Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStrokeProfile);
export default __webpack_public_path__ + "static/media/icon-stroke-profile.5a8145f4a7d00af4cd302c5fbade4cd6.svg";
export { ForwardRef as ReactComponent };